import { useEffect, useState } from 'react';
import { Col, Form, Layout, List, message, Modal, Row, Typography } from 'antd';
import AddButton from '../../Molecules/AddButton/AddButton';
import SimpleCardView from '../../Organisms/SimpleCardView/SimpleCardView';
import Rol from '../../../models/Rol';
import TaskType from '../../../models/TaskType';
import { ReactComponent as Plus } from '../../../res/svg/plus.svg';
import { useAppDispatch } from '../../../store/hooks/hooks';
import { deleteRole, getRoles, postRole, updateRole } from '../../../store/slice/rolSlice';
import { getTaskTypes } from '../../../store/slice/taskTypeSlice';
import RolForm from '../../Organisms/RolForm/RolForm';
import './RolesTemplate.less';
import Navbar from '../../Organisms/Navbar/Navbar';
import { permissionProfileAdmin, userSubMenu } from '../../../utils/functions';
import { useNavigate } from 'react-router-dom';
import SectionIndicator, { subsections } from '../../Molecules/SectionIndicator/SectionIndicator';

/**
 * @template RolesTemplate.tsx
 * @description Roles template to assign roles.
 * @return { template }
 */
function RolesTemplate() {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const [roles, setRoles] = useState<Rol[]>([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [tasksType, setTasksType] = useState<TaskType[]>([]);
  const [isEdit, setIsEdit] = useState(false);
  const [selectedRole, setSelectedRole] = useState<any>([]);
  let navigate = useNavigate();

  let rolesList = [...roles];
  const showRolModal = (show: boolean) => {
    setIsModalVisible(show);
    setIsEdit(false);
    dispatch(getTaskTypes()).then((value: any) => {
      if (value.payload.status) {
        setTasksType(value.payload.data);
      }
    });
  };
  const rolEditOnClick = (value: any) => {
    setIsModalVisible(true);
    setIsEdit(true);
    setSelectedRole(value.task);
    dispatch(getTaskTypes()).then((taskValue: any) => {
      if (taskValue.payload.status) {
        setTasksType(taskValue.payload.data);
      }
    });
    form.setFieldsValue({
      rol: value.task.rol,
      tipotareaId: value.task.tipostareas
        ? value.task.tipostareas.map((x: any) => {
          return x.id;
        })
        : value.task.tipotareaId,
      permiso: value.task.permiso,
      activo: value.task.activo,
    });
  };
  const handleCancel = () => {
    form.resetFields();
    setIsModalVisible(false);
    setIsEdit(false);
  };
  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        if (!isEdit) {
          values.activo = true;
          dispatch(postRole(values)).then((value: any) => {
            if (value.payload.status) {
              const addRolItem = [...roles, value.payload.data];
              setRoles(addRolItem);
              setIsModalVisible(false);
              form.resetFields();
              message.success('Rol agregado correctamente.');
            } else {
              message.error('Error : ' + value.payload.data.message);
            }
          });
        } else {
          rolesList = [...roles];
          values.id = selectedRole.id;
          const index = roles.findIndex((role) => {
            return role.id === selectedRole.id;
          });
          dispatch(updateRole(values)).then((value: any) => {
            if (value.payload.status) {
              rolesList[index] = { ...values };
              setRoles(rolesList);
              setIsModalVisible(false);
              form.resetFields();
              setIsModalVisible(false);
              message.success('Rol editado con exito.');
            } else {
              message.error('Error :' + value.payload.data.message);
            }
          });
        }
      })
      .catch((info) => {
        console.log('Validate Failed:', info);
      });
  };
  const rolDelete = () => {
    const index = roles.findIndex((item, key) => {
      return item.id === selectedRole.id;
    });
    dispatch(deleteRole(selectedRole.id)).then((value: any) => {
      if (value.payload.status) {
        rolesList.splice(index, 1);
        setRoles(rolesList);
        form.resetFields();
        setIsModalVisible(false);
        message.success('Rol eliminado con éxito.');
      } else {
        message.error('Error: Rol ligado a un usuario.');
      }
    });
  };
  useEffect(() => {
    //solo perfil admin pueden ingresar
    permissionProfileAdmin(navigate);
    dispatch(getRoles()).then((value: any) => {
      if (value.payload.status) {
        setRoles(value.payload.data);
      } else {
        setRoles([]);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const itemsCallback = (item: string) => {
    userSubMenu(item, navigate, dispatch);
  };

  return (
    <Layout>
      <Navbar subsection={'admin'} currentScreen={'admin/roles'} showItems={true} itemsCallback={itemsCallback} />
      <SectionIndicator subsection={subsections.roles} />
      <Layout className='tp-role__main'>
        <div className={'tp-role__add-button-container'}>
          <div>
            <AddButton
              icon={<Plus />}
              title='Crear Rol'
              showModal={showRolModal}
            />
          </div>
        </div>
        <Row>
          <Col>
            <div className='tp-role__card'>
              <List
                grid={{
                  gutter: 24,
                }}
                dataSource={roles}
                renderItem={(item, key) => (
                  <SimpleCardView
                    key={item.id}
                    task={item}
                    onClick={rolEditOnClick}
                    isRol={true}
                  />
                )}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Modal
              title={!isEdit ? 'Crear Rol' : 'Editar Rol'}
              visible={isModalVisible}
              okText={!isEdit ? 'Crear rol' : 'Guardar cambios'}
              width={472}
              className={'tp-role__modal'}
              onCancel={handleCancel}
              onOk={handleOk}
              cancelText='Cancelar'
            >
              <RolForm
                form={form}
                tasksType={tasksType}
                isEdit={isEdit}
                rolDelete={rolDelete}
              />
            </Modal>
          </Col>
        </Row>
      </Layout>
    </Layout>
  );
}

export default RolesTemplate;
